import { defineMessages } from 'react-intl'

export const shortcutMessages = defineMessages({
  code: {
    id: 'ShortcutQR.code',
    defaultMessage: 'Code'
  }
})
